import React from "react";
import { useTranslation } from "react-i18next";
import WaitlistTokenLanding from "../components/common/WaitlistTokenLanding";

export default function WaitlistVerifyPage() {
  const { t } = useTranslation();

  return (
    <WaitlistTokenLanding
      pageTitle="Waitlist Verification"
      type="verify"
      loadingTitle={t("Verifying your waitlist spot...")}
      loadingDesc={t("Please wait while we confirm your email address.")}
      successTitle={t("Email Verified Successfully!")}
      successDesc={t("Thank you for verifying your email. You are now officially on the waitlist.")}
      successToast={t("Email Verified Successfully!")}
      defaultErrorMsg={t("Invalid, expired, or already used token.")}
      errorTitle={t("Verification Failed")}
      autoRedirect={false}
    />
  );
}
